<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn link to="fornecedor/cadastro/novo" color="primary">
        <v-icon>mdi-plus</v-icon>
        Fornecedor
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma empresa" v-model="searchText"
                      style="max-width: 400px"
        :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.buildFilter());
    },
    onSelectItem() {
      this.onChangeFilter(this.buildFilter());
    },
    buildFilter() {
      if (!this.searchText) {
        return '';
      }
      return `nome like '%${this.searchText.toLowerCase()}%' or cnpj like '%${this.searchText.toLowerCase()}%'`;
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
};
</script>
